import { useEffect, useState } from "react";
import { Cookie, X } from "lucide-react";
import { readStoredConsent, updateConsent } from "@/lib/analytics";

export function ConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (readStoredConsent() === null) setVisible(true);
  }, []);

  if (!visible) return null;

  const decide = (granted: boolean) => {
    updateConsent(granted);
    setVisible(false);
  };

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Cookie consent"
      className="fixed inset-x-3 bottom-3 z-50 mx-auto max-w-3xl rounded-lg border bg-card p-4 shadow-lg sm:p-5"
    >
      <div className="flex items-start gap-3">
        <Cookie className="mt-0.5 h-5 w-5 shrink-0 text-primary" aria-hidden />
        <div className="flex-1 text-sm text-foreground">
          <p className="font-semibold">We value your privacy</p>
          <p className="mt-1 text-muted-foreground">
            We use cookies and similar technologies for analytics and to improve your
            experience. You can accept all, or reject non-essential cookies. Essential
            cookies are always active.
          </p>
        </div>
        <button
          type="button"
          aria-label="Dismiss cookie banner"
          onClick={() => decide(false)}
          className="rounded p-1 text-muted-foreground hover:bg-muted"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
      <div className="mt-3 flex flex-wrap justify-end gap-2">
        <button
          type="button"
          onClick={() => decide(false)}
          className="inline-flex items-center justify-center rounded-md border border-input bg-background px-4 py-2 text-sm font-medium hover:bg-accent"
        >
          Reject non-essential
        </button>
        <button
          type="button"
          onClick={() => decide(true)}
          className="inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90"
        >
          Accept all
        </button>
      </div>
    </div>
  );
}